import React, { useState, useImperativeHandle, forwardRef } from 'react'
// import DelMember from '@/components/delmember'
import gd from '@/assets/images/gengduo.png'
import xiuxi from '@/assets/images/xiuxi.png'
import jiedan from '@/assets/images/jiedan.png'
import './index.scss'
const MemberCard = (props, cRef) => {
    let { handleIshowDel, driverAcceptOrder, driverId, driverName, driverStatus, onlineTime, rewardAmount, driverPhone, index, setmembercardId } = props;
    //是否显示popover
    let [isShowPopover, setIsShowPopover] = useState(false);

    //控制popover隐藏
    const handleIsShowPopover = (e) => {
        let popoverList = document.querySelectorAll('.more_popover');
        if (popoverList.length > 0) {
            for (let i = 0, k = popoverList.length; i < k; i++) {
                popoverList[i].style.display = 'none';
            }
        }
        // 事件源判断
        let touchTarget = e.target.className;
        if (touchTarget === 'img_btn' || touchTarget === 'more_popover') {
            setIsShowPopover(!isShowPopover);
        }
        setmembercardId((pre) => {
            pre.delIndex = index
            return pre;
        });
    }
    // 抛给父组件的方法
    useImperativeHandle(cRef, () => ({
        handleSetIsShowPopover: () => {
            setIsShowPopover(false)
        }
    }), [])
    return (
        <div className="member-card__box" >
            <div className="right-top_btn">
                <img src={gd} alt="" className="img_btn" onClick={handleIsShowPopover} />
            </div>
            <h2>
                <span>{driverName}</span>
                {
                    driverStatus === 1 ? <img src={jiedan} alt='' /> : <img src={xiuxi} alt='' /> 
                }
            </h2>
            <div className="member-card__info">
                <h3>
                    <em>{driverAcceptOrder}单</em>
                    <b>今日完单</b>
                </h3>
                <h3>
                    <em>{parseInt(onlineTime / 60)}小时{onlineTime % 60}分</em>
                    <b>在线时长</b>
                </h3>
                <h3>
                    <em>{rewardAmount}元</em>
                    <b>流水金额</b>
                </h3>
            </div>
            {/* {
                isShowDel ? <DelMember handleIshowDel={handleIshowDel} /> : ''
            } */}
            {/* 显示popover */}
            {/* {
                isShowPopover ?
                    <span className="more_popover" onClick={handleIsShowPopover}>
                        <a href={'tel:' + driverPhone}>
                            <i className="iconfont icon-dianhua01"></i>
                        </a>
                        <span onClick={handleIshowDel.bind(this,driverId,driverPhone,driverName)}>
                            <i className="iconfont icon-shanchu"></i>
                        </span>
                    </span> : ''
            } */}
            <span className="more_popover" style={isShowPopover ? {} : { display: 'none' }} onClick={handleIsShowPopover}>
                <a href={'tel:' + driverPhone}>
                    <i className="iconfont icon-dianhua01"></i>
                </a>
                <span onClick={handleIshowDel.bind(this, driverId, driverPhone, driverName)}>
                    <i className="iconfont icon-shanchu"></i>
                </span>
            </span>
        </div>
    )
}
export default forwardRef(MemberCard)
